import React, { useState } from "react";
import Checkbox from "../checkboxes/checkbox/Checkbox";
import copyIcon from "../../images/files-page/table-icons/copy-icon.svg";
import editIcon from "../../images/files-page/table-icons/pen-icon.svg";
import deleteIcon from "../../images/files-page/table-icons/delete-icon.svg";
import Select from "../select/Select";
import "./settingsTable.scss";
import NumberInput from "../numberInput/NumberInput";
import YellowButton from "../buttons/defaultButton/yellowButton/YellowButton";

const SettingsTable = ({
    setEditModalOpen,
    setDependenceModalOpen,
    dataList,
    copyElementHandler,
    setEditElement,
    deleteElementHandler,
    editElementHandler,
    listCheckHandler,
    itemsList,
    checkAllHandler,
}) => {
    const configEditElementHandler = (id, title, parentId, sort) => {
        setEditElement({ id: id, title: title, parentId: parentId, sort: sort });
        setEditModalOpen(true);
    };

    const editSortElementHandler = (id, title, parentId) => {
        setEditElement({ id: id, title: title, parentId: parentId });
    };
    const editDependanceElementHandler = (id, title, parentId) => {
        setEditElement({ id: id, title: title, parentId: parentId });
        setDependenceModalOpen(true);
    };

    return (
        <table className="table">
            <thead>
                <tr>
                    <th>
                        <div className="table__header-left">
                            <Checkbox onChange={(e) => checkAllHandler(e.target.checked)} />
                            {/* <Select title={"Елементи оформлення"} width={"max-content"} /> */}
                        </div>
                    </th>
                    <th>Сортування</th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {dataList.map((dataListItem) => {
                    return (
                        <tr className="row" key={dataListItem.id}>
                            <td>
                                <div
                                    className="table__elements"
                                    style={{ paddingLeft: `${35 * dataListItem.depth}px` }}
                                >
                                    <Checkbox
                                        onChange={(e) => listCheckHandler(e)}
                                        checked={itemsList.includes(+dataListItem.id)}
                                        value={dataListItem.id}
                                    />
                                    {dataListItem.title}
                                </div>
                            </td>
                            <td
                                className="middle-element"
                                onClick={() =>
                                    editSortElementHandler(
                                        dataListItem.id,
                                        dataListItem.title,
                                        dataListItem.parent_id,
                                        dataListItem.sort
                                    )
                                }
                            >
                                <NumberInput
                                    type={"text"}
                                    inputValue={dataListItem.sort}
                                    editElementHandler={editElementHandler}
                                />
                            </td>
                            <td className="middle-element">
                                <YellowButton
                                    text={"Додати залежність"}
                                    padding={"9px 24px"}
                                    font={"13px"}
                                    onClick={() =>
                                        editDependanceElementHandler(
                                            dataListItem.id,
                                            dataListItem.title,
                                            dataListItem.parent_id,
                                            dataListItem.sort
                                        )
                                    }
                                />
                            </td>
                            <td>
                                <div className="table__settings">
                                    <div className="table__settings-functions">
                                        <div
                                            className="table__settings-functions-green-icon"
                                            onClick={() => copyElementHandler(dataListItem.id)}
                                        >
                                            <img src={copyIcon} alt="copy" />
                                        </div>
                                        <div
                                            className="table__settings-functions-green-icon"
                                            onClick={() =>
                                                configEditElementHandler(
                                                    dataListItem.id,
                                                    dataListItem.title,
                                                    dataListItem.parent_id,
                                                    dataListItem.sort
                                                )
                                            }
                                        >
                                            <img src={editIcon} alt="edit" />
                                        </div>
                                        <div
                                            className="table__settings-functions-red-icon"
                                            onClick={() => deleteElementHandler(dataListItem.id)}
                                        >
                                            <img src={deleteIcon} alt="delete" />
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default SettingsTable;
